import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import { IsValidToken } from "../../services/AuthenticationService";
import clientInformation, { getClientItem } from '../login/ClientInfo';
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/PriorityMethods';

export const PriorityMethods = () => {
    const t = useTranslations(translations);
    const navigate = useNavigate();
    const [arrayPriorityDeposits, setArrayPriorityDeposits] = useState(JSON.parse(getClientItem('ArrayPriorityMethods')));

    useEffect(() => {

        IsValidToken(getClientItem('Token')).then(async function (response) {

        }

        ).catch(function (error) {
            navigate('/expired/');
        })

    }, []);

    function GetFormURL(Key) {
        if (arrayPriorityDeposits[Key].PaymentType.toLowerCase() == "")
            return "/deposits/creditcard/" + arrayPriorityDeposits[Key].DepositID
        else if (arrayPriorityDeposits[Key].PaymentType.toLowerCase() == "crypto")
            return "/deposits/crypto/" + arrayPriorityDeposits[Key].DepositID
        else if (arrayPriorityDeposits[Key].PaymentType.toLowerCase() == "ewallet")
            switch (arrayPriorityDeposits[Key].ImageName.toLowerCase()) {
                case "quickerzelle":
                    {
                        return "/deposits/zelle/QuickerZelle";
                        break;
                    }
                default: {
                    return "/deposits/ewallet/" + arrayPriorityDeposits[Key].DepositID;
                    break;
                }
            }
        else if (arrayPriorityDeposits[Key].PaymentType.toLowerCase() == "money gram")
            return "/deposits/moneygram/"
        else
            return "";
    }

    return (
        <div className="componentload">
            {arrayPriorityDeposits.length != 0 && <div className="mt-5">
                < div className="title">
                    <div className="container">
                        <h4 className="txt-primary text-title-color">{t.title}</h4>
                    </div>
                </div>
                <div className="row">
                    {arrayPriorityDeposits.map((item) => (
                        <div className="col-xxl-4 col-md-4 col-sm-4 col-xs-4">
                            <Link key={item.Key} to={GetFormURL(item.Key)} className="box-deposit box-green mb-2 mt-2">
                                <div className="row">
                                    <div className="col-md-3 col-sm-12">
                                        <div className="image-wrapper">
                                            <span className="icon-single">
                                                <img alt="" src={"/svg/" + item.ImageName + ".svg"} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-8 col-sm-12 text-center limit-text">
                                        <span className="d-none d-md-block">{t.min}:${item.MinDeposit == 0 ? 1 : item.MinDeposit} - {t.max}:{item.MaxDeposit == 0 ? t.noLimit : '$' + item.MaxDeposit}</span>

                                    </div>
                                    <div className="col-md-3 limit-text d-none d-md-block ">

                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>}
        </div>
    );
}
